import { render, staticRenderFns } from "./DowntimeReasonList.vue?vue&type=template&id=f4296afc&"
import script from "./DowntimeReasonList.vue?vue&type=script&lang=js&"
export * from "./DowntimeReasonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports